import { render, staticRenderFns } from "./HistoricalOrgProvinceFilter.vue?vue&type=template&id=74e988e5&scoped=true&"
import script from "./HistoricalOrgProvinceFilter.vue?vue&type=script&lang=js&"
export * from "./HistoricalOrgProvinceFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e988e5",
  null
  
)

export default component.exports